import { NodeStates } from '@candulabs/core';
import { Node, NodeData, NodeId, SerializedNode } from '@candulabs/craft';
import { CSSProperties } from 'react';

import { Conditional } from 'craft/types/conditionals';
import { ContentCollection, DocumentPlacements } from 'craft/types/contentDocument';

import { Action } from './actions';
import { CssSelector, CssSelectorId } from './cssSelector';
import { Media } from './media';

export type CraftNodes = Record<NodeId, SerializedNode & { custom: CustomNodeData }>;

export interface SerializedNodeTree {
  rootNodeId: NodeId;
  nodes: Record<NodeId, SerializedNode>;
}

export interface CustomNodeData {
  displayName?: string;
  /**
   *  Store any actions
   *  equvalent to $tutorialDocument.nodes[id].data.actions
   */
  actions?: Action[];
  /**
   *  Store any custom value that is specific to the node
   *  equvalent to $tutorialDocument.nodes[id].data.custom
   */
  custom?: Record<string, unknown>;

  conditionals?: Record<string, Conditional>;

  /**
   * Media breakpoints.
   * Equivalent to $tutorialDocument.nodes[id].data.media
   */
  media?: Media;

  /**
   *  Store the node css
   *  equvalent to $tutorialDocument.nodes[id].css
   */
  css?: CSSProperties;

  cssSelectors?: Record<CssSelectorId, CssSelector>;

  /**
   * Store document state resolvers
   */
  states?: NodeStates;

  /**
   * Store Placements
   */
  placements?: DocumentPlacements;

  /**
   * Stores a node's collections, if any
   */
  collections?: ContentCollection[];
}

interface CustomNode {
  data: NodeData & {
    custom: CustomNodeData;
  };
}

// an altered definition of Node that has our custom data instead of the `any` that the classic
// default comes with
export type CraftNode = Node & CustomNode;

export enum CommonNodeProperties {
  Multiple = 'MULTIPLE',
}
